// Shared constants for admin professionals views

export const PROFESSIONAL_TYPES = [
  { value: 'financial_advisor', label: 'Financial Advisor' },
  { value: 'estate_attorney', label: 'Estate Attorney' },
  { value: 'cpa_tax', label: 'CPA / Tax Professional' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'family_therapist', label: 'Family Therapist' }
];

export const getTypeLabel = (type) => {
  const found = PROFESSIONAL_TYPES.find(t => t.value === type);
  return found ? found.label : type;
};
